import { createAction } from '@reduxjs/toolkit';

import { DateRange } from 'interfaces/shared.interface';

export const setIsEditMode = createAction<boolean>('SET_IS_EDIT_MODE');
export const setDateRange = createAction<DateRange>('SET_EDIT_MODE');
